import {Model} from "../Model";
import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";

@usingJsonToModelConvertor
export class PersonalDelivery extends Model {

    @fromJsonObject({key: "available"})
    public available!: boolean;

    @fromJsonObject({key: "only_online_pay"})
    public onlyOnlinePay!: boolean;

}

@usingJsonToModelConvertor
export class ManualServiceDelivery extends Model {

    @fromJsonObject({key: "available"})
    public available!: boolean;

    @fromJsonObject({key: "payment_by_client"})
    public paymentByClient!: boolean;

}

@usingJsonToModelConvertor
export class ExpressDelivery extends Model {

    @fromJsonObject({key: "available"})
    public available!: boolean;

    @fromJsonObject({key: "price"})
    public price!: number;

}

@usingJsonToModelConvertor
export class DeliveryOptions extends Model {

    @fromJsonObject({key: "personal", modelClass: PersonalDelivery, isArray: false})
    public personal!: PersonalDelivery;

    @fromJsonObject({key: "manual", modelClass: ManualServiceDelivery, isArray: false})
    public manualService!: ManualServiceDelivery;

    @fromJsonObject({key: "express", modelClass: ExpressDelivery, isArray: false})
    public express!: ExpressDelivery;

}

@usingJsonToModelConvertor
export class CTCPaymentOption extends Model {

    @fromJsonObject({key: "available"})
    public available!: boolean;

}

@usingJsonToModelConvertor
export class IPGPaymentOption extends Model {

    @fromJsonObject({key: "available"})
    public available!: boolean;

    @fromJsonObject({key: "wage"})
    public wage!: number;

}

@usingJsonToModelConvertor
export class POSPaymentOption extends Model {

    @fromJsonObject({key: "available"})
    public available!: boolean;

    @fromJsonObject({key: "only_with_express"})
    public onlyWithExpress!: boolean;

}

@usingJsonToModelConvertor
export class PaymentOptions extends Model {

    @fromJsonObject({key: "ctc", modelClass: CTCPaymentOption, isArray: false})
    public ctc!: CTCPaymentOption;

    @fromJsonObject({key: "ipg", modelClass: IPGPaymentOption, isArray: false})
    public ipg!: IPGPaymentOption;

    @fromJsonObject({key: "pos", modelClass: POSPaymentOption, isArray: false})
    public pos!: POSPaymentOption;

}

@usingJsonToModelConvertor
export class OverviewData extends Model {

    @fromJsonObject({key: "delivery_options", modelClass: DeliveryOptions, isArray: false})
    public deliveryOptions!: DeliveryOptions;

    @fromJsonObject({key: "payment_options", modelClass: PaymentOptions, isArray: false})
    public paymentOptions!: PaymentOptions;

    @fromJsonObject({key: "ipg_wage"})
    public ipgWage!: number;

}

export type DeliveryOptionsTypes = PersonalDelivery|ManualServiceDelivery|ExpressDelivery|null;
export type PaymentOptionsTypes = POSPaymentOption|IPGPaymentOption|CTCPaymentOption|null;